import {AuthService} from './../../services/auth.service';
import {Component, OnInit, ElementRef} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import { UserService } from '../../services/user.service';
import {NgEventBus} from 'ng-event-bus';
import {TranslateService} from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  email: string;
  password: string;
  errorMessage: string;
  firstTime = '';
  passwordNew = '';
  repeatPassword = '';
  passwordsMatch = false;
  showPassword = false;
  showMatchPassword = false;
  invalidPassword: boolean;
  messageSuccess = false;
  activationValid = false;

  constructor(
    public router: Router,
    public auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private el: ElementRef,
    private userService: UserService,
    private eventBus: NgEventBus,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    if (this.activatedRoute.snapshot.paramMap.get('token')) {
      this.firstTime = this.activatedRoute.snapshot.paramMap.get('token');
    }

    this.redirectIfAuthenticated();

    document.body.style.background = '#f0f2f5';
    this.email = '';
    this.password = '';
  }

  private redirectIfAuthenticated(): void {
    const userData = this.auth.getUser();
    if (!userData || !userData.token) return;

    this.auth.validateSession().subscribe(
      () => {
        const roleId = userData.role ? userData.role.id : null;
        if (roleId === 5) {
          this.router.navigate(['/admin/conversations']);
        } else {
          this.router.navigate(['/admin']);
        }
      },
      () => {} // Token inválido/expirado: se queda en login
    );
  }

  login() {
    this.auth.login(this.email.trim(), this.password).subscribe(
      (result: any) => {
        const role = result.data.role.name;
        result.data.token = result.token;
        this.auth.persistUser(result.data);
        if(role !== 'agent') {
          this.router.navigate(['/admin']);
        } else { this.router.navigate(['/admin/conversations'])}
      },
      (error) => {
        this.errorMessage = error.message;
      });
  }

  public changeVisibilityConfirm() {
    if (!this.showMatchPassword) {
      this.el.nativeElement.querySelector('#verifyPassword').setAttribute('type', 'text');
      this.el.nativeElement.querySelector('#visibilityConfirmIcon').setAttribute('class', 'fa fa-eye');
      this.showMatchPassword = true;
    } else {
      this.el.nativeElement.querySelector('#verifyPassword').setAttribute('type', 'password');
      this.el.nativeElement.querySelector('#visibilityConfirmIcon').setAttribute('class', 'fa fa-eye-slash');
      this.showMatchPassword = false;
    }
  }

  public changeVisibility() {
    if (!this.showPassword) {
      this.el.nativeElement.querySelector('#passwordInput').setAttribute('type', 'text');
      this.el.nativeElement.querySelector('#visibilityIcon').setAttribute('class', 'fa fa-eye');
      this.showPassword = true;
    } else {
      this.el.nativeElement.querySelector('#passwordInput').setAttribute('type', 'password');
      this.el.nativeElement.querySelector('#visibilityIcon').setAttribute('class', 'fa fa-eye-slash');
      this.showPassword = false;
    }
  }

  public validatePassword() {
    let hasLower = false;
    let hasUpper = false;
    let hasNum = false;
    let hasAtLeast = false;

    const lowercaseRegex = new RegExp('(?=.*[a-z])'); // has at least one lower case letter
    if (lowercaseRegex.test(this.passwordNew)) {
      hasLower = true;
    }

    const uppercaseRegex = new RegExp('(?=.*[A-Z])'); // has at least one upper case letter
    if (uppercaseRegex.test(this.passwordNew)) {
      hasUpper = true;
    }

    const numRegex = new RegExp('(?=.*\\d)'); // has at least one number
    if (numRegex.test(this.passwordNew)) {
      hasNum = true;
    }
    if (this.passwordNew.length >= 8) {
      hasAtLeast = true;
    }

    this.invalidPassword = this.passwordFails([hasLower, hasUpper, hasNum, hasAtLeast]);
  }

  passwordFails(checks: boolean[]): boolean {
     let counter = 0;
    for (let i = 0; i < checks.length; i++) {
      if (checks[i]) {
        counter += 1;
      }
    }
    return counter < 4;
 }

 confirmPassword() {
   // tslint:disable-next-line:triple-equals
   if (this.repeatPassword != this.passwordNew) {
     this.passwordsMatch = true;
   } else {
     this.passwordsMatch = false;
   }
 }

 activateUser() {
   this.userService.activateUser(this.passwordNew, this.firstTime).subscribe(response => {
     this.messageSuccess = true;
     this.firstTime = '';
     this.eventBus.cast('notification: userActivated', {
       type: 'success',
       message: this.translate.instant('auth.login.userActivated', response),
       hide: '',
       loading: false
     });
     setTimeout(() => {
        this.messageSuccess = false;
     }, 5000);
   }, error => {
     this.activationValid = true;
     setTimeout(() => {
       this.activationValid = false;
      this.router.navigate(['/login']);
     }, 5000);
   });
 }

}
